export const BASIC_TEMPLATE_FIELDS = `
  id
  name
  categoryId
  snippet
  subject
`

export const BY_ID_TEMPLATE_FIELDS = `
  ${BASIC_TEMPLATE_FIELDS}
  body
`

export const getAllQuery = () => `
query CommentTemplateQuery(
  $categoryIds: [String]
  $keyword: String
  $source: String
) {
  commentTemplates(categoryIds: $categoryIds, keyword: $keyword, source: $source) {
    ${BASIC_TEMPLATE_FIELDS}
  }
}
`

export const getByIdQuery = `
query CommentTemplateByIdQuery(
  $id: String
) {
  commentTemplate(id: $id) {
    ${BY_ID_TEMPLATE_FIELDS}
  }
}
`
